export default {"src":"/_next/static/media/people.fdbdf963.svg","height":18,"width":22};